import { Drawer } from "@mui/material";
import React from "react";
import useMedia from "use-media";
import ListItem from "./Content/ListItem";
import { useSidebar } from "../../contexts/sidebar/SidebarContext";

interface SideBarProps {
  open?: boolean;
  onClose?: () => void;
}
const SideBar: React.FC<SideBarProps> = ({ open, onClose }) => {
  const isMobile = useMedia({ maxWidth: 900 });
  const { isCompact, toggleCompact } = useSidebar();
  const sidebarWidth = isCompact ? 80 : 285;

  return (
    <Drawer
      {...(isMobile ? { open, onClose } : { variant: "permanent" })}
      sx={{
        width: `${sidebarWidth}px`,
        flexShrink: 0,
        paddingTop: 50,
        "& .MuiDrawer-paper": {
          width: `${sidebarWidth}px`,
          minWidth: `${sidebarWidth}px`,
          maxWidth: `${sidebarWidth}px`,
          boxSizing: "border-box",
          marginTop: isMobile ? "0" : "100px",
          height: isMobile ? `calc(100% - ${20}px)` : `calc(100% - ${100}px)`,
          overflowX: "hidden",
        },
      }}
    >
      <ListItem isCompact={isCompact} onToggleCompact={toggleCompact} />
    </Drawer>
  );
};

export default SideBar;
